import { connect } from 'react-redux';
import { compose } from 'recompose';
import { createStructuredSelector } from 'reselect';
import { withIntl } from 'ha/i18n';

import {
  getCollectionFilter,
  getLocation,
  isSearchByPartner,
  getlangURLListState,
} from 'ha/pages/Search/selectors';

import SearchCategories from 'ha/pages/Search/components/SearchCategories';

const enhance = compose(
  connect(
    createStructuredSelector({
      canonicalCollection: getCollectionFilter,
      place: getLocation,
      langUrlList: getlangURLListState,
      isSearchByPartner,
    }),
  ),
  withIntl,
);

export default enhance(SearchCategories);
